module.exports = __webpack_public_path__ + "assets/d64d95394026f7cfb51cf1821cb1c4c6.mp3";